import { svg } from 'lit';

export const checkIcon = svg`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.99999H5V11H19V9.99999ZM19 13H11V14H19V13ZM21 6.74999H3C2.58579 6.74999 2.25 7.08578 2.25 7.49999V16.5C2.25 16.9142 2.58579 17.25 3 17.25H21C21.4142 17.25 21.75 16.9142 21.75 16.5V7.49999C21.75 7.08578 21.4142 6.74999 21 6.74999ZM20.25 15.75H3.75V8.24999H20.25V15.75Z" fill="#786E5C"/>
</svg>
`;
